var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-bread-crumbs"},[_c('router-link',{staticClass:"modules-button",attrs:{"to":"/main"}},[_vm._v("Модули")]),_c('router-link',{staticClass:"module-name-button",attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }